import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LockOutlineIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lock_outline"}/>
}
